import * as Sentry from "@sentry/react";

const normalizeError = (err) => {
    if (err instanceof Error) return err;
    if (typeof err === "string") return new Error(err);
    // Object or unknown — stringify into an Error
    try {
        return new Error(JSON.stringify(err));
    } catch {
        return new Error(String(err));
    }
};

export const sendErrorToSentry = (err, errorInfo) => {
    if (!err) return null;

    const error = normalizeError(err);
    let eventId = null;

    Sentry.withScope((scope) => {
        if (errorInfo) {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
        }
        // Pass non-Error originals as extra context
        if (!(err instanceof Error)) {
            scope.setExtra("originalError", err);
        }
        eventId = Sentry.captureException(error);
    });

    return eventId;
}